div<template>
    <pm-custom-dialog v-if="visible" v-model="visible" id="pdf-viewer-dialog">
        <h2>{{ title }}</h2>

        <div style="max-width: 90%; padding-top: Calc(1.41 * 90%); overflow: hidden; position: relative; border-radius: 3px; margin: 20px auto; margin-bottom: 12px;">

            <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; overflow: hidden; ">
                <div id="pdf-preview-container">
                    <img ref="previewImg" :src="imgUrl" style="max-width: 100%; border-radius: 3px; border: 1px solid #ccc; box-shadow: 5px 5px 0px rgba(0,0,0,.15); " />
                </div>
            </div>


            <div v-if="dialogData.pdfPages && dialogData.pdfPages > 1 && currentPage > 1" style="position: absolute; left: 10px; bottom: 20px; overflow: hidden; ">
                <span @click="currentPage--" style="font-size: 11px; border-radius: 20px; display:inline-block; background: #fff; border: 2px solid #ddd; padding: 3px 10px; margin: 0 6px;">
                    &larr; prev page
                </span>
            </div>

            <div v-if="dialogData.pdfPages && dialogData.pdfPages > 1 && currentPage < dialogData.pdfPages" style="position: absolute; right: 10px; bottom: 20px; overflow: hidden; ">
                <span @click="currentPage++" style="font-size: 11px; border-radius: 20px; display:inline-block; background: #fff; border: 2px solid #ddd; padding: 3px 10px; margin: 0 6px;">
                    next page &rarr;
                </span>
            </div>
        </div>


        <v-btn style="border-radius: 16px; margin-bottom: 30px;" large class="primary" @click="share">
            <span style="text-transform: uppercase!important;">
                Share PDF link
            </span>
        </v-btn>
    </pm-custom-dialog>
</template>

<style>
    #pdf-viewer-dialog .pm-custom-dialog-content {
        max-width: 80vw;
        max-height: 95vh!important;
        height: auto!important;
        width: 100%;
        /*height: 100%;*/
    }

    @media (max-aspect-ratio: 6/9) {
        #pdf-viewer-dialog .pm-custom-dialog-content {
            max-width: 90vw;
            max-height: 90vh!important;
            height: auto!important;
            width: 100%;
        }
    }
</style>

<script>
import PinchZoom from "pinch-zoom-js";
import PmCustomDialog from "./base-dialog.vue";
import { share } from '@/utils/device/share';
export default {
    components: {
        PmCustomDialog,
    },
    props: {
        dialogData: {
            type: Object,
            default: () => ({}),
        }
    },
    data: () => ({
        visible: true,
        currentPage: 1,
    }),
    watch: {
        visible() {
            if (this.visible === false) {
                if (typeof this.pz !== 'undefined') this.pz.disable();
                this.$emit('close');
            }
        }
    },
    mounted() {
        console.log(this.dialogData);
        this.$refs.previewImg.onload = () => {
            this.initZoom();
        }
    },
    computed: {
        imgUrl() {
            return "https://cdn.denticalc.com/user/" + this.dialogData.pdfUrl + ".preview_" + this.currentPage + ".jpg";
        },
        title() {
            if (typeof this.dialogData.title !== 'undefined') return this.dialogData.title;
            return "Your PDF is ready";
        },
    },
    methods: {
        initZoom() {
            const el = document.getElementById('pdf-preview-container');
            if (el) this.pz = new PinchZoom(el, {});
            else {
                console.log(el);
                captureException("Could not attach PinchZoom to element");
            }
        },
        show() {
            this.visible = true;
        },
        share() {
            const url = "https://cdn.denticalc.com/user/" + this.dialogData.pdfUrl;
            const text = "";
            const subject = "";
            // @ts-ignore
            share(url);
        }
    },
}
</script>
